const baseCallbackUrl = 'https://kickwin.visiontrek.io/';
// const baseCallbackUrl = 'http://localhost:5070/'
export {baseCallbackUrl}


const getHeadersApi = `${baseCallbackUrl}get-headers`;
export {getHeadersApi}


const subscribe_api = `${baseCallbackUrl}subscribe-user`;
export {subscribe_api}


const updateStatusApi = `${baseCallbackUrl}update/activation-logs`
export {updateStatusApi}